import  {ReactComponent as BocconiHeaderSVG}  from  './BocconiHeaderWithLogo.svg'

const BocconiHeader = () => {
    return <BocconiHeaderSVG style={{
        marginBottom: '-4px' // Dont know why I need this ;(
    }}/>
}

export default BocconiHeader